import { style } from '@vanilla-extract/css';

export const htmlSnippet = style({
  padding: '8px var(--wt-padding)',
  whiteSpace: 'normal',
  overflowWrap: 'normal',
});
